import { useQuery } from '@tanstack/vue-query'
import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from '../propertyQueryKeys'
import { getPropertyFees } from '../propertyFeesEndpoints'

export function usePropertyFeesQuery(propertyId: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: computed(() => propertyKeys.fees(toValue(propertyId))),
    queryFn: () => getPropertyFees(toValue(propertyId)),
    enabled: () => Boolean(toValue(propertyId)),
  })
}
